import type { FilterGroupItem, FilterLineItem, FilterOperatorType } from '@civilgrid/ui/utils';

const PROJECT_MANAGER_FILTER_ID = 'projectManagerId';
const PROJECT_MANAGER_EQUALS_OPERATOR: FilterOperatorType = { id: 'eq', label: 'Equals' };
const PROJECT_MANAGER_NOT_EQUALS_OPERATOR: FilterOperatorType = { id: 'neq', label: 'Does Not Equal' };

export type MapListSection = 'bookmarked' | 'my' | 'all';

/**
 * Build filters for one map list section.
 * - bookmarked: shared filters only (bookmark filter is applied via bookmarkedOnly in the query).
 * - my: shared filters + PM is current user (excludeBookmarked applied in the query).
 * - all: shared filters + PM is not current user (excludeBookmarked applied in the query).
 * When currentUserId is null, "My" uses eq undefined (no matches); "All" has no PM filter.
 */
export function getMapListFiltersForSection(
  sharedFilters: FilterGroupItem,
  section: MapListSection,
  currentUserId: string | null,
): FilterGroupItem {
  if (section === 'bookmarked') {
    return sharedFilters;
  }
  if (section === 'all' && !currentUserId) {
    return sharedFilters;
  }
  const pmLine: FilterLineItem = {
    type: 'line',
    id: `map-list-pm-${section}`,
    operator: 'and',
    filterType: { id: PROJECT_MANAGER_FILTER_ID, label: 'Project Manager' },
    operatorType: section === 'my' ? PROJECT_MANAGER_EQUALS_OPERATOR : PROJECT_MANAGER_NOT_EQUALS_OPERATOR,
    value: currentUserId ?? undefined,
  };

  if (sharedFilters.items.length === 0) {
    return {
      ...sharedFilters,
      operator: 'and',
      items: [pmLine],
    };
  }

  return {
    type: 'group',
    id: `map-list-${section}`,
    operator: 'and',
    items: [sharedFilters, pmLine],
  };
}
